<div class="col-xs-4 col-md-4 col-centered col-slider no-padding row">
  <div class="small text-center" *ngIf="!client.isLoaded">загрузка...</div>
  <freighter-client-form *ngIf="client.isLoaded" [freighter]="freighter" [client]="client" (back)="onBack()"
                         (saved)="onSaved($event)"></freighter-client-form>
</div>
